export const LISTS_WITH_PROHIBITED_ITEMS = [
  'Dangerous goods',
  'Hazardous goods',
  'Flammable goods',
  'Firearms (including imitation firearms or firearm components)',
  'Bladed products or articles',
  'Cannabidiol products',
  'Tobacco products, or any products containing nicotine',
  'Alcohol including wines, beers and spirits',
  'Perishable food (non-ambient foods such as fresh fruit, vegetables and frozen or chilled foodstuffs, frozen water and dry ice)',
  'Pharmaceutical products',
  'Batteries',
  'Biological substances',
  'Paints, wood varnishes and enamels',
  'Glass or any articles (or part of them) that are made of glass, porcelain, earthenware or other similar materials',
  'Jewellery (including watches) with a value of over £250',
  'Personal effects',
  'Liquids over 100ml',
  'Cash or documents which can be exchanged for cash or goods or services (for example cheques, credit/debit cards, vouchers with a face value, event tickets)',
  'Living or dead animals, fish or birds, or any living organism of any type (including trees, plants, or cut flowers)',
  'Human or animal remains (including ashes)',
  'Any goods prohibited by the law or regulation of any government or public or local authority of any country where the goods are carried, or goods that are destined for any country, company, organisation or individual that is subject to any applicable national or international export or import control or regulation',
  'Any goods which are destined to a PO box or BFPO address',
  'Any goods which require a licence or permit in order to transport or store the Parcel and/or which are subject to import, export, or transportation restrictions (including Dual-use Goods) imposed by the laws applicable in the country of expedition, dispatch, transit, destination, or otherwise',
  'Any goods intended for export on a temporary basis (i.e. non-permanent with the intention of being returned to Great Britain)',
];
